<template>
  <div id="asphaltMixContract" v-loading="loading">
    <div class="buttons" v-loading="loading">
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="PrintContractD"
        style="margin: 10px 0"
        >打印 </el-button
      ><el-button
        type="primary"
        icon="el-icon-plus"
        @click="saveContractA"
        style="margin: 10px 10px"
        v-if="dialogForm.approveStatus != 3 && dialogForm.approveStatus != 2"
        >保存
      </el-button>
      <el-button type="primary" @click="setWatermark" style="margin: 10px 0"
        >设置水印
      </el-button>
      <div style="display: inline-flex; width: 300px;margin-left:150px;">
        <el-input v-model="inputPages" placeholder="总页数" style="margin-left: 10px;"></el-input>
        <el-input v-model="inputHeight" placeholder="单页高" style="margin-left: 10px;"></el-input>
        <el-input v-model="inputPosx" placeholder="偏移量" style="margin-left: 10px;"></el-input>
      </div>
    </div>
    <div
      ref="HTMLasphaltMixContent"
      id="HTMLasphaltMixContent"
      :class="printClass"
      :key="printClass"
    >
      <div class="HTMLasphaltMixContract1">
        <div style="position: relative">
          <p
            class="contract_word_p"
            style="margin-bottom: 0;font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: center"
          >
            <span style="font-size: 20px; font-family: 宋体; color: red"></span
            ><span style="font-size: 20px; font-family: 宋体; color: red"></span
            ><span style="font-size: 40px; font-family: 宋体; color: red"
              >青岛路桥建设集团有限公司</span
            >
          </p>
          <p
            class="contract_word_p"
            style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: right"
          >
            <span
              style="
                position: absolute;
                z-index: 8;
                left: 10px;
                top: 2px;
                width: 44px;
                height: 57px;
              "
              ><img
                width="44"
                height="57"
                src="@/assets/images/subContract/LaborContract/logo.png"
                alt="路桥logo"
            /></span>
          </p>
        </div>
        <hr style="margin-top: 0" />
        <p style="text-align: center; line-height: 150%; margin-bottom: 20px">
          <strong
            ><span style="font-family: 黑体; line-height: 150%; font-size: 24px"
              >沥青拌合料加工合同</span
            ></strong
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >合同编号：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="serialNumber"
              >{{
                detailForm.serialNumber ? detailForm.serialNumber : ""
              }}</span
            >
          </span>
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >签订时间：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="signDate"
              >{{ detailForm.signDate ? detailForm.signDate : "" }}</span
            ></span
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >签约地点：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="signPlace"
              >{{ detailForm.signPlace || "青岛市" }}</span
            ></span
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >甲方：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="partyA"
              >{{ detailForm.partyA }}</span
            ></span
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >乙方：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="partyB"
              >{{ detailForm.partyB ? detailForm.partyB : "" }}</span
            ></span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >根据《中华人民共和国民法典》及有关法律法规的规定，遵循平等、自愿和诚实信用的原则，双方就甲方<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 4cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
               class="partyAs"
              >{{ detailForm.partyAs }}</span
            ></span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >工程<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 4cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="projectmc"
              >{{ detailForm.projectmc }}</span
            ></span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >的事项协商一致，根据本工程的具体情况，订立以下合同条款：</span
          >
        </p>
        <p style="margin-left: 53px; line-height: 31px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              >第一条&nbsp;</span
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              >名称、型号及配套设备</span
            ></strong
          >
        </p>
        <p
          style="
            text-indent: 56px;
            line-height: 31px;
            font-family: 楷体_GB2312;
            font-size: 19px;
          "
        >
          <span
            style="
              border-bottom: 1px solid rgb(44, 62, 80);
              outline: 0;
              min-width: 3cm;
              display: inline-block;
              text-indent: 5px;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="bhzName"
            >{{ detailForm.bhzName }}</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">拌合站</span>
          <span
            style="
              border-bottom: 1px solid rgb(44, 62, 80);
              outline: 0;
              min-width: 1.5cm;
              display: inline-block;
              text-indent: 5px;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="bhzNum"
            >{{ detailForm.bhzNum }}</span
          ><span
            >台，拌合机设置地点<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 3cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="bhzAddress"
              >{{ detailForm.bhzAddress }}</span
            ></span
          >
        </p>
        <p
          style="
            margin-left: 53px;
            line-height: 31px;
            font-family: 楷体_GB2312;
            font-size: 19px;
          "
        >
          <strong
            ><span style="font-family: 楷体_GB2312">第二条</span>
            <span style="font-family: 楷体_GB2312">合同期限：</span></strong
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >自<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 2cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="year"
              >{{ detailForm.year }}</span
            >年<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 1cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="month"
              >{{ detailForm.month }}</span
            >月<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 1cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="day"
              >{{ detailForm.day }}</span
            >日至甲方工程完工时结束。</span
          >
        </p>
        <p style="margin-left: 53px; line-height: 31px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              ><span style="font-family: 楷体_GB2312">第三条</span>
              <span style="font-family: 楷体_GB2312"
                >沥青混凝土拌合加工</span
              ></span
            ></strong
          >
        </p>
        <table
          ref="onlyPriceTable"
          width="100%"
          style="border-collapse: collapse; border-width: 1px"
          :key="tableKey"
        >
          <thead style="display: table-header-group">
            <tr class="firstRow">
              <td
                width="102"
                valign="top"
                style="
                  padding: 0px 2px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 19px"
                    >名称</span
                  >
                </p>
              </td>
              <td
                width="47"
                valign="top"
                style="
                  padding: 0px 2px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 19px"
                    >单位</span
                  >
                </p>
              </td>
              <td
                width="113"
                valign="top"
                style="
                  padding: 0px 2px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 19px"
                    >暂定数量</span
                  >
                </p>
              </td>
              <td
                width="76"
                valign="top"
                style="
                  padding: 0px 2px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 24px">
                  <span style="font-family: 楷体_GB2312; font-size: 19px"
                    >不含税单价</span
                  >
                </p>
              </td>
              <td
                width="47"
                valign="top"
                style="
                  padding: 0px 2px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 19px"
                    >税率</span
                  >
                </p>
              </td>
              <td
                width="66"
                valign="top"
                style="
                  padding: 0px 2px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 24px">
                  <span style="font-family: 楷体_GB2312; font-size: 19px"
                    >含税单价</span
                  >
                </p>
              </td>
              <td
                width="94"
                valign="top"
                style="
                  padding: 0px 2px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 19px"
                    >含税总价</span
                  >
                </p>
              </td>
              <td
                width="51"
                valign="top"
                style="
                  padding: 0px 2px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 19px"
                    >备注</span
                  >
                </p>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr
              style="height: 35px; page-break-inside: avoid"
              v-for="item in asphalMixtableList"
              :key="item.id"
            >
              <td
                width="102"
                style="
                  border-style: solid;
                  padding: 0px 2px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column0 }}
              </td>
              <td
                width="47"
                style="
                  border-style: solid;
                  padding: 0px 2px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column1 }}
              </td>
              <td
                width="113"
                style="
                  border-style: solid;
                  padding: 0px 2px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column2 }}
              </td>
              <td
                width="76"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                style="
                  border-style: solid;
                  padding: 0px 2px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
              >
                {{ item.column3 }}
              </td>
              <td
                width="47"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                style="
                  border-style: solid;
                  padding: 0px 2px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
              >
                {{ item.column4 }}
              </td>
              <td
                width="66"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                style="
                  border-style: solid;
                  padding: 0px 2px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
              >
                {{ item.column5 }}
              </td>
              <td
                width="94"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                style="
                  border-style: solid;
                  padding: 0px 2px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
              >
                {{ item.column6 }}
              </td>
              <td
                width="51"
                style="
                  border-style: solid;
                  padding: 0px 2px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column7 }}
              </td>
            </tr>
          </tbody>
        </table>
        <div
          style="display: flex"
          v-if="dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3"
        >
          <el-tooltip
            class="item"
            effect="dark"
            content="添加行"
            placement="top-start"
          >
            <i class="el-icon-plus" @click="addItem"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="删除行"
            placement="top-start"
          >
            <i class="el-icon-minus" @click="delItem"></i>
          </el-tooltip>
        </div>
        <p style="text-indent: 37px; line-height: 31px; margin-top: 10px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >1.此单价包含乙方拌合机基础临建费用（含人、材、机等所有费用）、拌合机设备使用及折旧费（含设备进出场及安装拆除费）、装载机上料费和洒水车降尘费及后勤保障车费（含驾驶员工资、燃油等）、人工费（含食宿）、水电费（包括加工及生活用）等与拌合生产相关的配套辅助设备、设施、管理、协调、安全生产、利润、税金等所有费用以及为拌合生产所进行的设备维修、试验调试材料等辅助工作费用，并且此单价为固定单价，在合同履行期间不做任何调整，如乙方单方面变更价格，属乙方违约，甲方有权终止合同，并拒付所欠乙方拌合加工款，同时乙方承担给甲方造成全部的损失。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >2.不含税单价固定不变，税金随着国家规定税率的调整而调整，最终税金金额以开具发票时的国家税率计算为准。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >3.拌合加工数量由甲方根据工程实际需用数量安排确定，结算数量以乙方拌合机拌和出厂数量（甲方认可的电子自动计量打印设备打印的出厂数量凭证）及甲方施工现场实际签收的数量为准。</span
          >
        </p>
        <p style="text-indent: 47px; line-height: 31px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              ><span style="font-family: 楷体_GB2312">第四条</span>
              <span style="font-family: 楷体_GB2312">结算方式与付款</span></span
            ></strong
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >4.1沥青拌合数量结算以吨为单位，最终结算数量以双方签字认可的出厂数量凭证为准。每个月1日为双方对账确认日期，确认上一月份乙方所拌合加工数量及金额，双方须在对账确认单上签字认可并加盖单位印章。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >4.2合同签订拌合机正常生产后，按照业主计量款拨付同期按比例支付乙方拌合加工款。以转帐支票或电子汇票方式付款，不以现金方式支付。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            ><span style="font-family: 楷体_GB2312"
              >乙方必须指派专人到甲方收款</span
            ><span style="font-family: 楷体_GB2312"
              >,收款前必须向甲方出具符合国家税务规定的等额的增值税专用发票(<span
                style="
                  border-bottom: 1px solid rgb(44, 62, 80);
                  outline: 0;
                  min-width: 1cm;
                  display: inline-block;
                  text-indent: 5px;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                class="retio"
                >{{ detailForm.retio }}</span
              ></span
            ></span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >税率<span style="font-family: 楷体_GB2312"
              >)，若未开具发票则甲方不予付款；已开具发票的，出具符合财务规定的收据，并在第一次收取款项时，必须持与本合同乙方单位名称一致的授权收款委托书交甲方财务备案；如被授权收款人有变动，则由乙方单位重新开具授权收款委托书交甲方财务备案，否则，甲方不予付款。</span
            ></span
          >
        </p>
        <p style="text-indent: 47px; line-height: 31px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              ><span style="font-family: 楷体_GB2312">第五条</span>
              <span style="font-family: 楷体_GB2312">拌合加工要求</span></span
            ></strong
          >
        </p>
        <p
          style="
            text-indent: 37px;
            line-height: 31px;
            font-family: 楷体_GB2312;
            font-size: 19px;
          "
        >
          <span
            >在甲方制定的生产计划时段内，乙方按照甲方提供的试验配比、技术要求、生产计划，为甲方拌和生产合格的沥青拌合料。总体计划在</span
          ><span
            style="
              border-bottom: 1px solid rgb(44, 62, 80);
              outline: 0;
              min-width: 2cm;
              display: inline-block;
              text-indent: 5px;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="year1"
            >{{ detailForm.year1 }}</span
          >年<span
            style="
              border-bottom: 1px solid rgb(44, 62, 80);
              outline: 0;
              min-width: 1cm;
              display: inline-block;
              text-indent: 5px;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="month1"
            >{{ detailForm.month1 }}</span
          >月<span
            style="
              border-bottom: 1px solid rgb(44, 62, 80);
              outline: 0;
              min-width: 1cm;
              display: inline-block;
              text-indent: 5px;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="day1"
            >{{ detailForm.day1 }}</span
          >日以前完成设备调试、试验配比、试拌等准备工作，达到正常拌和生产要求。合同履行期间，为保证甲方工程质量和工期，乙方不得承揽其它拌合加工任务，否则乙方自行承担由此给甲方造成的一切经济损失。
        </p>
        <p style="text-indent: 47px; line-height: 31px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              ><span style="font-family: 楷体_GB2312">第六条</span>
              <span style="font-family: 楷体_GB2312">双方责任</span></span
            ></strong
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.1 甲方责任</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.1.1甲方负责及时提供碎石、矿粉、沥青等材料。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.1.2甲方负责生产技术指导，指导乙方调试生产配比、试拌、拌和生产。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.1.3甲方须制定总体拌和生产计划，计划调整时须及时通知乙方，同时每次拌和生产时须提前通知乙方。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.1.4甲方负责按照合同条款及时为乙方支付拌合加工费用。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.2 乙方责任</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.2.1乙方必须保证沥青拌和机、装载机及洒水车等相关辅助设备设施状况良好，数量合理，以及按照甲方要求，满足甲方工程施工使用。为保证拌和机正常生产所需的相关配套配件、材料等均由乙方自己负责并承担费用。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.2.2乙方须设沥青拌合站现场管理经理在生产过程中必须服从甲方的管理指导，按照甲方提供的配合比和要求的质量、数量、时间进行生产。乙方操作人员应严格按照技术要求认真操作，保证沥青拌合料的质量，生产过程中必须服从甲方的计划要求，根据工程需要安排昼夜生产。若因乙方原因影响甲方施工计划造成的经济损失由乙方承担。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.2.3乙方对所拌合加工的沥青拌合料质量、规格、要求和标准均是乙方应该做到的和应尽的义务，同样也是乙方向甲方的承诺，无条件的遵守。无条件的服从和执行甲方、业主、监理公司所提出的质量、规格等缺陷，并做到对方满意。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.2.4乙方负责当地政府及民众的关系协调，费用由乙方承担。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.2.5乙方负责拌和机矿粉、骨料及沥青的电子秤设备的标定校验并承担全部费用，同时乙方须及时提供甲方、业主及监理所要求的真实有效的设备标定证书。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.2.6
            乙方负责拌和机及相关配套设备的操作、维修、保养，配备的操作、维修人员及生产工人必须保证甲方连续生产的要求，同时正常生产过程中乙方设备出现故障后维修时间不得超过24小时。
          </span>
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.2.7乙方承担拌和生产过程中所产生的粉尘及其它污染所发生的费用。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              ><span style="font-family: 楷体_GB2312">第七条</span>
            </span></strong
          ><strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              >劳务用工及工资支付管理</span
            ></strong
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">7</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >.1
            乙方必须遵守国家法律、行政法规和政策的规定，及时办理和完善劳动用工、社会保险等手续，合法使用员工，保护员工合法权益，不得拖欠或克扣员工、（农）民工工资。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">7</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >.2
            乙方未能及时支付其员工或（农）民工工资时，乙方同意：若乙方就所劳务工程拖欠农民工工资，</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >出现上访现象，</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >甲方有权从</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >乙方拌合加工款中扣除相应金额</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >发放乙方所欠农民工工资，</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">并且</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >乙方应向甲方支付等额违约金。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">7</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >.3
            甲方有权对乙方的员工工资支付等情况进行监督、检查，乙方不得以任何理由拒绝，并应为甲方的监督、检查提供便利。若乙方违反国家法律、行政法规及有关国家政策，拖欠或克扣员工工资，经甲方催告后在合理时间仍不纠正的，甲方将有权暂停支付</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">拌合</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >加工款或单方面解除合同，由此造成的一切损失和责任由乙方承担。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 37px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              >第八条</span
            ></strong
          ><strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              >&nbsp;<span style="font-family: 楷体_GB2312"
                >安全环保施工、检查、防护</span
              ></span
            ></strong
          >
        </p>
        <p style="text-indent: 37px; line-height: 37px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">8</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >.1 乙方拌合机</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">施工</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >须持有合法有效的《安全生产许可证》</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >及符合环保部门规定的环评手续</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >，并严格遵守《中华人民共和国安全生产法》、国务院《建设工程安全生产条例》</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >、《中华人民共和国环境保护法》等法律法规的规定</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">，</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >乙方拌合机及配套设备设施必须符合</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >国家和有关部门的安全</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">、</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >环保管理规定并按安全</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">、</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >环保等相关部门的要求对拌合机及配套设备加装相关安全</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">、</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >环保措施</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">，</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >保证甲方工程施工的顺利进行；加强</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >拌合机操作</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >人员与机械的施工安全管理，对施工现场的防台、防火、防爆、防汛和防盗等采取严格的安全环保的防护措施，严格遵照甲方现场的一切安全环保的管理规定，保证施工现场安全</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">、</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">环保</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">、</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >文明施工。</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >严格遵守国家相关临时用电规范的要求，</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >强制采用三相五线的用电要求，并承担由于管理不力或技术措施不到位造成的事故责任和由此发生的费用；严格按安全环保标准进行施工，随时接受行业安全环保检查人员依法实施的监督检查，采取必要的安全环保防护措施，消除事故及环境污染隐患。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">8</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">.2</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">&nbsp;</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >乙方在动力设备、输电线路、地下管道、密封防震车间、易燃易爆地段以及临街交通要道附近施工时，施工开始前应向甲方提出安全环保防护措施</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >或《安全环保施工专项方案》</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >，经甲方认可后实施，安全环保防护措施费用</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >已包含在乙方沥青拌合料加工单价中，不再另计。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 31px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              ><span style="font-family: 楷体_GB2312">第九条</span>
              <span style="font-family: 楷体_GB2312">违约责任</span></span
            ></strong
          >
        </p>
        <p style="text-indent: 42px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >9.1合同履行期间，甲乙双方应按照合同规定条款履行各自职责。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >9.2乙方应高效合理组织生产，如因设备原因、操作失误造成的废料，由乙方承担责任并赔偿甲方的损失。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >9.3乙方要积极按时完成甲方的生产计划，如因设备或乙方人员的原因未完成甲方生产要求，导致工期拖延，乙方承担责任及给甲方造成的损失。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">9.4</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >合同双方均不得采用虚假记录、虚假计量或其他方法在拌合加工数量上弄虚作假。否则，除虚假部分的加工数量不得做为加工费计算依据外，还须得按虚假部分加工数量的加工费的十倍计算违约方应予承担的违约金。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >9.5合同签订前，乙方向甲方提供一套完整的供方企业资质，若乙方企业不具备承担本合同所明确的生产、经营资质，或合同签订后发现该企业已被工程所在地政府建管部门取消和限制在当地生产、经营等违法、违规现象，乙方承担全部的行政和法律后果，若给甲方造成损失的，应承担相应的损害赔偿责任。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >9.6乙方单位若发生企业变更、注册地址以及通信地址变更，必须向甲方提供企业变更后的相关材料，否则，甲乙双方发生纠纷，由乙方承担全部法律责任。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >9.7其他因乙方原因给甲方造成的一切损失，均由乙方承担。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              ><span style="font-family: 楷体_GB2312">第十条</span>
              <span style="font-family: 楷体_GB2312"
                >合同争议的解决方式：</span
              ></span
            ></strong
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >本合同的解释和执行适用中华人民共和国法律。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            ><span style="font-family: 楷体_GB2312"
              >本合同在履行过程中发生的争议，由双方当事人坦诚友好协商解决；也可由需方当地工商行政管理部门调解</span
            ><span style="font-family: 楷体_GB2312"
              >,
              如果协商或者调解不能解决，应向签约地点所在地法院提起诉讼。因解决争议而产生的所有费用，包括但不限于诉讼费、律师费、评估费、鉴定费、审计费、差旅费等均由乙方承担。</span
            ></span
          >
        </p>
        <p style="margin-left: 32px; line-height: 31px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              ><span style="font-family: 楷体_GB2312">第十一条</span>
              <span style="font-family: 楷体_GB2312"
                >本合同解除的条件：</span
              ></span
            ></strong
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >按《民法典》有关条款执行。</span
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              >第十二条</span
            ></strong
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >&nbsp;<span style="font-family: 楷体_GB2312"
              >本合同经甲乙双方企业法定代表人或委托代理人签字并加盖合同专用章后，方能生效。</span
            >
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              ><span style="font-family: 楷体_GB2312">第十三条</span>
              <span style="font-family: 楷体_GB2312">合同份数：</span></span
            ></strong
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >本合同共<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 1cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="contractTotal"
              >{{ detailForm.contractTotal || "五" }}</span
            >份，甲方执<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 1cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="contractAnum"
              >{{ detailForm.contractAnum || "四" }}</span
            >份，乙方执<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 1cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="contractBnum"
              >{{ detailForm.contractBnum || "一" }}</span
            >份，具同等法律效力。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              ><span style="font-family: 楷体_GB2312">第十四条</span>
              <span style="font-family: 楷体_GB2312">其它约定</span></span
            ></strong
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >14.1在正常拌合生产前拌和机的生产配合比调试、沥青拌合料试拌工作，由乙方操作，乙方人员在甲方指导下进行，因配合比调试，试验拌合而产生的相关费用（拌合费、电费、人工费等）由乙方承担。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >14.2乙方负责拌合生产过程中的安全生产管理工作，必须为其拌合加工及相关人员办理相关人身意外伤害保险并承担费用。在合同履行过程中发生的一切安全事故所造成的经济损失和应承担的责任由乙方全部承担，甲方不承担连带责任。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">14.3</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >乙方工人上岗前，乙方必须对工人进行安全教育或安全交底并让工人佩戴好安全防护用品（比如：安全帽、帆布手套等）后方可进入沥青拌合机场地。进入沥青拌合机场地后，如因乙方人员不听从现场管理人员的管理而出现安全事故，其责任由乙方全部承担，甲方不承担连带责任</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">。</span>
        </p>
        <p style="margin-bottom: 0; text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >14.4乙方拌和机在完成甲方工程施工生产任务后，双方对乙方拌合机所剩甲方原材料（水泥、矿粉、骨料、沥青等）进行盘点确认，乙方必须如数归还甲方所剩所有原材料</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">。</span>
        </p>
        <p style="margin-bottom: 0; text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >14.5甲乙双方间的债权、债务，在未达成一致的前提下，均不得以任何方式转让给第三方。</span
          >
        </p>
        <p style="margin-bottom: 0; text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >14.6本合同未涉及的条款，双方可签订补充协议，但须经甲乙双方企业法定代表人或委托代理人签字并加盖合同专用章后，方能生效,</span
          ><span style="font-family: 宋体; font-size: 14px">&nbsp;</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            ><span style="font-family: 楷体_GB2312"
              >补充协议规定与本合同具有同等效力。</span
            >
            &nbsp;&nbsp;</span
          >
        </p>
        <p style="margin-bottom: 0; text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >14.7乙方拌和机必须重新喷涂甲方企业的标志及底色，甲方根据业主要求对乙方拌和机加装信息化管理配套设施，乙方必须无条件给予配合，乙方拌和机应具备相关硬件要求。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >14.8其他未尽事宜，双方友好协商解决。</span
          >
        </p>
        <!-- <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">&nbsp;</span>
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">&nbsp;</span>
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">&nbsp;</span>
        </p> -->
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">&nbsp;</span>
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">&nbsp;</span>
        </p>
        <table width="100%" style="border-collapse: collapse">
          <tbody>
            <tr
              style="height: 100px; font-family: 楷体_GB2312; font-size: 19px"
              class="firstRow"
            >
              <td
                width="284"
                style="
                  border-width: 0;
                  border-color: windowtext;
                  padding: 2px 7px;
                  border-style: solid;
                "
              >
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >甲方单位（盖章）：</span
                  ><span
                    style="font-size: 19px"
                    class="partA_gongzhang"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_gongzhang }}</span
                  >
                </p>
                <p style="line-height: 150%">
                  <span
                    style="
                      font-family: 楷体_GB2312;
                      line-height: 150%;
                      font-size: 19px;
                    "
                    >&nbsp;</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >法人或授权代表（签字）：</span
                  ><span
                    style="font-size: 19px"
                    class="partA_sign"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_sign }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 19px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px">联系电话：</span>
                  <span
                    class="partA_phone"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_phone }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >日期：</span
                  ><span
                    style="font-size: 19px"
                    class="partA_date"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_date }}</span
                  >
                </p>
              </td>
              <td
                width="285"
                style="
                  border-width: 0;
                  border-left: 0;
                  padding: 2px 7px;
                  border-style: solid;
                "
              >
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >乙方单位（盖章）：</span
                  ><span
                    style="font-size: 19px"
                    class="partB_gongzhang"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_gongzhang }}</span
                  >
                </p>
                <p style="line-height: 150%">
                  <span
                    style="
                      font-family: 楷体_GB2312;
                      line-height: 150%;
                      font-size: 19px;
                    "
                    >&nbsp;</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >法人或委授权代表（签字）：</span
                  ><span
                    style="font-size: 19px"
                    class="partB_sign"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_sign }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 19px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px">联系电话：</span>
                  <span
                    class="partB_phone"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_phone }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >日期：</span
                  ><span
                    style="font-size: 19px"
                    class="partB_date"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_date }}</span
                  >
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="printWrap" v-show="false">
        <div
          v-html="asphaltMixContent"
          class="mainHtml"
          id="printasphaltMixContent"
        ></div>
      </div>
    </div>
    <setWatermarkDialog
      ref="setWatermarking"
      @setWaterMarkFun="setWaterMarkFun"
    ></setWatermarkDialog>
  </div>
</template>

<script>
import {
  getServiceContractDetailService, //获取合同填充内容
} from "@/services/allContractServices";
import printJS from "print-js";
import { mixins } from "@/page/contract/template/mixin.js";
import setWatermarkDialog from "../../commonCell/setWatermarkDialog.vue";
import { addPageNum, getTableData } from "../common.js";
import { addPageNumCustom } from "../common.js";

export default {
  name: "asphaltMixContract",
  mixins: [mixins],
  components: {
    setWatermarkDialog,
  },
  data() {
    return {
      asphaltMixContent: "", //富文本编辑器内容
      watermark: [""],
      list: [1, 2, 3, 4, 5, 6],
      saveflag: false,
      detailForm: { ...this.dialogForm },
      tableKey: Math.random(),
      asphalMixtableList: [
        {
          id: 0,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 1,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 2,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 3,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 4,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 5,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 6,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 7,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
      ], //中间表格数据
      inputPages: "",
      inputHeight: 1010,
      inputPosx: 37,
    };
  },
  methods: {
    addItem() {
      let len = this.asphalMixtableList.length - 2;
      let id = (this.asphalMixtableList[len]?.id ?? 0) + 1;
      let item = {
        id: id,
        column0: "",
        column1: "",
        column2: "",
        column3: "",
        column4: "",
        column5: "",
        column6: "",
        column7: "",
      };
      this.asphalMixtableList.push(item);
    },
    delItem() {
      if (this.asphalMixtableList.length > 0)
        this.asphalMixtableList.splice(-1, 1);
    },
    /**
     * 初始化全部订单表格数据,配置表格列等数据
     *
     **/
    initOrderDetailTable() {
      this.getTableData();
    },
    //获取一条劳务合同信息
    getsubServiceContractDetail(id) {
      if (!id) return;
      let param = {};
      param.id = id;
      getServiceContractDetailService(param)
        .then((res) => {
          if (res.code == 10000000) {
            let data = {};
            if (res.data.subContractPrintVO) {
              data = res.data.subContractPrintVO;
              this.watermark = res.data.subContractPrintVO.watermark || [""];
              if (data.content) {
                this.saveflag = true;
                this.detailForm = JSON.parse(data.content);
                if (this.detailForm.asphalMixtableList)
                  this.asphalMixtableList = JSON.parse(
                    this.detailForm.asphalMixtableList
                  );
                this.asphalMixtableList.forEach((item, index) => {
                  item.id = index + 1;
                  return item;
                });
              } else {
                this.detailForm = { ...this.dialogForm };
                this.asphalMixtableList = [
                  {
                    id: 0,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 1,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 2,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 3,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 4,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 5,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 6,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 7,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                ];
              }
            }
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
          this.loading=false;
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
          this.loading=false;
        });
    },
    saveContractA() {
      if (this.detailForm.approveStatus == 2) {
        this.$alert("合同为待审核无法修改", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      // this.getValues();
      const table = this.$refs.onlyPriceTable;
      this.asphalMixtableList = getTableData(table, this.asphalMixtableList, 8);
      this.detailForm.asphalMixtableList = JSON.stringify(
        this.asphalMixtableList
      );
      this.tableKey = Math.random();
      this.saveCommon('asphaltMixContract');
    },
    getValues() {
      // let Id = document.getElementById("HTMLasphaltMixContent");
      let Id = document.getElementsByClassName(this.printClass)[0];
      this.detailForm.serialNumber =
        Id.getElementsByClassName("serialNumber")[0].innerText.trim();
      this.detailForm.partyA =
        Id.getElementsByClassName("partyA")[0].innerText.trim();
      this.detailForm.partyB =
        Id.getElementsByClassName("partyB")[0].innerText.trim();
        this.detailForm.partyAs =
        Id.getElementsByClassName("partyAs")[0].innerText.trim();
      this.detailForm.signPlace =
        Id.getElementsByClassName("signPlace")[0].innerText.trim();
      Id.getElementsByClassName("signPlace")[0].innerHTML =
        this.detailForm.signPlace;
      this.detailForm.signDate =
        Id.getElementsByClassName("signDate")[0].innerText.trim();
      Id.getElementsByClassName("signDate")[0].innerHTML =
        this.detailForm.signDate;
      this.detailForm.projectmc =
        Id.getElementsByClassName("projectmc")[0].innerText.trim();

      this.detailForm.bhzName =
        Id.getElementsByClassName("bhzName")[0].innerText.trim();
      this.detailForm.bhzNum =
        Id.getElementsByClassName("bhzNum")[0].innerText.trim();
      this.detailForm.bhzAddress =
        Id.getElementsByClassName("bhzAddress")[0].innerText.trim();
      this.detailForm.year =
        Id.getElementsByClassName("year")[0].innerText.trim();
      this.detailForm.month =
        Id.getElementsByClassName("month")[0].innerText.trim();
      this.detailForm.day =
        Id.getElementsByClassName("day")[0].innerText.trim();

      this.detailForm.retio =
        Id.getElementsByClassName("retio")[0].innerText.trim();

      this.detailForm.year1 =
        Id.getElementsByClassName("year1")[0].innerText.trim();
      this.detailForm.month1 =
        Id.getElementsByClassName("month1")[0].innerText.trim();
      this.detailForm.day1 =
        Id.getElementsByClassName("day1")[0].innerText.trim();
      this.detailForm.contractTotal =
        Id.getElementsByClassName("contractTotal")[0].innerText.trim();
      this.detailForm.contractAnum =
        Id.getElementsByClassName("contractAnum")[0].innerText.trim();
      this.detailForm.contractBnum =
        Id.getElementsByClassName("contractBnum")[0].innerText.trim();

        Id.getElementsByClassName("partyAs")[0].innerHTML =
        this.detailForm.partyAs;
        Id.getElementsByClassName("projectmc")[0].innerHTML =
        this.detailForm.projectmc;
      Id.getElementsByClassName("bhzName")[0].innerHTML =
        this.detailForm.bhzName;
      Id.getElementsByClassName("bhzNum")[0].innerHTML = this.detailForm.bhzNum;
      Id.getElementsByClassName("bhzAddress")[0].innerHTML =
        this.detailForm.bhzAddress;
      Id.getElementsByClassName("year")[0].innerHTML = this.detailForm.year;
      Id.getElementsByClassName("month")[0].innerHTML = this.detailForm.month;
      Id.getElementsByClassName("day")[0].innerHTML = this.detailForm.day;
      Id.getElementsByClassName("retio")[0].innerHTML = this.detailForm.retio;
      Id.getElementsByClassName("year1")[0].innerHTML = this.detailForm.year1;
      Id.getElementsByClassName("month1")[0].innerHTML = this.detailForm.month1;
      Id.getElementsByClassName("day1")[0].innerHTML = this.detailForm.day1;
      Id.getElementsByClassName("contractTotal")[0].innerHTML =
        this.detailForm.contractTotal;
      Id.getElementsByClassName("contractAnum")[0].innerHTML =
        this.detailForm.contractAnum;
      Id.getElementsByClassName("contractBnum")[0].innerHTML =
        this.detailForm.contractBnum;

      this.detailForm.partA_gongzhang =
        Id.getElementsByClassName("partA_gongzhang")[0].innerText;
      Id.getElementsByClassName("partA_gongzhang")[0].innerHTML =
        this.detailForm.partA_gongzhang;
      this.detailForm.partA_sign =
        Id.getElementsByClassName("partA_sign")[0].innerText;
      Id.getElementsByClassName("partA_sign")[0].innerHTML =
        this.detailForm.partA_sign;
      this.detailForm.partA_phone =
        Id.getElementsByClassName("partA_phone")[0].innerText;
      Id.getElementsByClassName("partA_phone")[0].innerHTML =
        this.detailForm.partA_phone;
      this.detailForm.partA_date =
        Id.getElementsByClassName("partA_date")[0].innerText;
      Id.getElementsByClassName("partA_date")[0].innerHTML =
        this.detailForm.partA_date;

      this.detailForm.partB_gongzhang =
        Id.getElementsByClassName("partB_gongzhang")[0].innerText;
      Id.getElementsByClassName("partB_gongzhang")[0].innerHTML =
        this.detailForm.partB_gongzhang;
      this.detailForm.partB_sign =
        Id.getElementsByClassName("partB_sign")[0].innerText;
      Id.getElementsByClassName("partB_sign")[0].innerHTML =
        this.detailForm.partB_sign;
      this.detailForm.partB_phone =
        Id.getElementsByClassName("partB_phone")[0].innerText;
      Id.getElementsByClassName("partB_phone")[0].innerHTML =
        this.detailForm.partB_phone;
      this.detailForm.partB_date =
        Id.getElementsByClassName("partB_date")[0].innerText;
      Id.getElementsByClassName("partB_date")[0].innerHTML =
        this.detailForm.partB_date;
    },
    //打印当前合同
    PrintContractD() {
      if (this.dialogForm.approveStatus != 3) {
        this.$alert("合同尚未通过审核，无法打印", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      // let Id = document.getElementById("HTMLasphaltMixContent");
      let Id = document.getElementsByClassName(this.printClass)[0];
      let elementsToRemove = Id.querySelectorAll(".page-num");
      elementsToRemove.forEach(function (element) {
        element.parentNode.removeChild(element);
      });
      //addPageNum(Id);
      addPageNumCustom(Id, 0, "default", this.inputPages, this.inputHeight, this.inputPosx);
      
      this.$set(
        this,
        "asphaltMixContent",
        this.$refs.HTMLasphaltMixContent.innerHTML
      );
      this.$nextTick(() => {
        printJS({
          printable: "printasphaltMixContent",
          type: "html",
          targetStyles: ["*"],
          ignoreElements: ["no-print", "bc", "gb"],
          scanStyles: false,
          style: `@page { size: auto; margin:10mm } p{line-height: 31px} .HTMLasphaltMixContract1 {background: url("data:image/svg+xml,%3Csvg width='200' height='200' xmlns='http://www.w3.org/2000/svg'%3E%3Ctext x='50%25' y='50%25' font-size='14' fill-opacity='0.3' text-anchor='middle' dominant-baseline='middle' transform='rotate(-35, 100 100)'%3E${this.watermark.join(
            ";"
          )}%3C/text%3E%3C/svg%3E");
}`,
        });
      });
    },
    //设置水印
    setWatermark() {
      this.$refs.setWatermarking.showwaterMarkDialog(
        this.subServiceContractId,
        this.watermark
      );
    },
    setWaterMarkFun(val) {
      this.watermark = val;
      let param = {
        warterMark: this.watermark,
        version: "1.0",
        flag: 2,
      };
      this.$emit("savePrintInfo", param);
    },
  },
};
</script>

<style>
#HTMLasphaltMixContent {
  /* position: relative; */
  width: 20cm;
  padding: 0 10px;
  margin-top: 58px;
  box-shadow: 0px 4px 12px 2px #bbb;
}

.buttons {
  width: 22cm;
  height: 56px;
  position: fixed;
  top: 90px;
  background: white;
  z-index: 9;
}

.printWrap {
  width: 21cm;
  margin: 30px auto;
  padding: 5mm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

.mainHtml {
  width: 21cm;
}

p {
  line-height: 31px;
}
</style>
